//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
let d=[[[0,"DrawingStandard",1,0]],[[["documentType","formSheetName"],"AddFormSheetMapping",{},2,0],[["documentType"],"ResetFormSheetMapping",{},1,0],[[],"ResetToDefault",{},0,0]],[]];
SPLM.AME.FormSheetSettingsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.FormSheetSettingsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.FormSheetSettingsBuilder.SymbolDrawingStandard = Object.freeze({
    "Iec" : "Iec", "Ansi" : "Ansi", "NonStandard" : "NonStandard"});

export default SPLM;